import {LitElement, html, unsafeCSS} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {unsafeHTML} from "lit/directives/unsafe-html.js";
import documentLibraryCSS from './bg-document-card.scss?inline';
import {SlBadge} from "@shoelace-style/shoelace";

export interface BgDocumentCardInterface {
    documentType: string,
    tags: string[],
    tagLabels: string[],
    url: string,
    title: string,
    fileSize: string,
}

export interface BgTagInterface {
    label: string,
    href: string,
    value?: string,
    selectorPrefix?: string,
    disclaimer?: string,
}

const shoelaceElementFactory = (tagName: string) => {
    // Define a list of all Shoelace components being used
    customElements.define(tagName, SlBadge);
};

/**
 * An example element.
 *
 * @slot - This element has a slot
 * @csspart button - The button
 */

@customElement('bg-document-card')
export class BgDocumentCard extends LitElement {

    constructor(args: BgDocumentCardInterface) {
        super();
        if (!args) {
            return
        }
        ;
        this.title = args.title;
    }

    @property()
    docsHint = '';

    @property({type: String})
    documentType = "";

    @property({type: String})
    tags = "";

    @property({type: String})
    tagLabels = "";

    @property({type: String})
    url = "";

    @property({type: String})
    title = "";

    @property({type: String})
    fileSize = "";

    render() {
        let tags = JSON.parse(this.tags);
        let tagLabels = JSON.parse(this.tagLabels);
        return html`
            <a href="${this.url}" target='_blank' data-tags='${this.tags}'
               class="bg-document-library-item bg-advanced-filter-card-display">
                <div class="bg-document-library-item-content">
                    <div class="bg-document-library-item-title">${this.title}</div>
                    <div class="bg-document-library-tag-list">
                        ${this.renderTags(tags, tagLabels)}
                    </div>
                </div>
                <div class="bg-document-library-item-footer">
                    <div class="bg-document-library-item-footer-item">
                        <strong>Type: </strong>${this.documentType}
                    </div>
                    <div class="bg-document-library-item-footer-item">
                        <strong>Size: </strong>(${this.fileSize} MB)
                    </div>
                </div>
            </a>
        `
    }

    static styles = [
        unsafeCSS(documentLibraryCSS)
    ]

    renderTags(tags: BgTagInterface[], tagLabels: string[]) {
        let tagHtml = ''
        let disclaimerList = tags.filter(tag => tag.disclaimer !== null && tag.disclaimer != "")
        for (let tag of disclaimerList) {
            var disclaimer = tag?.disclaimer ?? "";
            var highlighted = disclaimer !== "" ? "highlighted" : "";
            tagHtml += `<sl-badge class="bg-document-list-label ${highlighted}">${tag.label}</sl-badge>`
        }
        if (tagLabels && tagLabels.length > 0) {
            for (let tagLabel of tagLabels) {
                if (disclaimerList.filter(tag => tag.label === tagLabel).length === 0) {
                    tagHtml += `<sl-badge class="bg-document-list-label">${tagLabel}</sl-badge>`
                }
            }
        }
        return unsafeHTML(tagHtml);
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'bg-document-card': BgDocumentCard
    }
}
